import {  useJustificationPage } from '../../contexts/JustificationPageContext'

import '../../styles/main.css';

export default function ComparisionTypeFilter () {

    const { selectedComparisionTypeId, setSelectedComparisionTypeId, comparisionTypes } = useJustificationPage()

    return(

        <section className="w-full bg-neutro borda-cinza rounded-[7px] p-4 flex justify-between gap-[10px] my-4 mx-auto">
                      
            {comparisionTypes.map((comparisionType) => (
                
                <button
                    key={comparisionType.id}
                    className={`
                        w-full [transition:0.3s_ease] text-[0.8rem] outline-[none] border-[none] 
                        p-[4px] rounded-[4px] cursor-pointer font-saira
                        ${  
                            selectedComparisionTypeId === comparisionType.id
                            ? 'bg-azul-profundo-m text-white'
                            : 'bg-white text-black hover:bg-azul-profundo-c hover:text-white'
                        }
                        z-10 h-10 w-[215px]
                    `}
                    onClick={() => setSelectedComparisionTypeId(comparisionType.id)}
                >
                    {comparisionType.name}
                </button>

            ))}
		 
        </section>
    )
}


